export const MANAGEMENT_DEFAULT_PAGE = '/dashboard';
export const DOCTOR_DEFAULT_PAGE = '/patients';
